import { render, staticRenderFns } from "./ScoringCode.vue?vue&type=template&id=cbe077a4&"
import script from "./ScoringCode.js?vue&type=script&lang=js&"
export * from "./ScoringCode.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports